import { getCurrencies, getOrderOrigins, getPurchasingShippingMethods, getPurchasingShippingTerms, getSalesShippingMethods, getTaxRates, getWarehouseShippingMethods } from "src/utils/apiRequests";
import { useResponseLegacy } from "../useResponse";


export const useCurrencies = () => {
    const [response] = useResponseLegacy<any[]>(getCurrencies);
    return response;
}
export const useOrderOrigins = () => {
    const [response] = useResponseLegacy<any[]>(getOrderOrigins);
    return response;
}

export const useTaxRates = () => {
    const [response] = useResponseLegacy<any[]>(getTaxRates);
    return response;
}
export const useSalesShippingMethods = () => {
    const [response] = useResponseLegacy<any[]>(getSalesShippingMethods);
    return response;
}

export const useWarehouseShippingMethods = () => {
    const [response] = useResponseLegacy<any[]>(getWarehouseShippingMethods);
    return response;
}
export const usePurchasingShippingMethods = () => {
    const [response] = useResponseLegacy<any[]>(getPurchasingShippingMethods);
    return response;
}
export const usePurchasingShippingTerms = () => {
    const [response] = useResponseLegacy<any[]>(getPurchasingShippingTerms);
    return response;
}
